import { takeEvery } from 'redux-saga/effects';

import * as payoutActions from 'store/modules/payouts';
import { load } from './utils';

export default function* listenLoad() {
  yield takeEvery(payoutActions.loadPayouts.toString(), load);
}
